import styled from "@emotion/styled";
import { LightColors } from "../../../../../light-theme";

export const GoalContents = styled.div({
  background: LightColors.white,
  border: `1px solid ${LightColors.grey1}`,
});
